module.exports = __webpack_public_path__ + "static/media/MaintenanceCryingEgg.89f85d7a.svg";